module.exports = {"321003001":"邗上街道","321003002":"蒋王街道","321003003":"汊河街道","321003005":"双桥街道","321003006":"梅岭街道","321003007":"甘泉街道","321003009":"新盛街道","321003010":"竹西街道","321003052":"瘦西湖街道","321003100":"公道镇","321003101":"方巷镇","321003102":"槐泗镇","321003103":"瓜洲镇","321003108":"杨寿镇","321003110":"杨庙镇","321003111":"西湖镇","321003201":"双桥乡","321003350":"平山乡","321003351":"城北乡","321003401":"江苏省扬州高新技术产业开发区","321003402":"维扬经济开发区","321003403":"物流园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321003.json
// module id = 843
// module chunks = 0